<template>
  <section>
    <iframe class="iframeWindow" :src="iframeSrc" frameborder="0"></iframe>
  </section>
  
</template>

<script>
export default {
  name: 'Tickets',

  data() {
    return {
      iframeSrc: '',
    };
  },

  beforeMount() {
    this.iframeSrc = `${this.$store.state.template.tickets.iframeURL}`;
    // this.iframeSrc = `https://www.sympla.com.br/blitzar__1248665`;
  },
};
</script>

<style>
</style>